var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogsOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.319,
    height: 22.539,
    viewBox: "0 0 19.319 22.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.379,1.5H10.94V3.647h6.44ZM13.086,15.453h2.147V9.013H13.086ZM21.7,8.358l1.524-1.524a11.858,11.858,0,0,0-1.513-1.513L20.191,6.845A9.659,9.659,0,1,0,21.7,8.358ZM14.159,21.892a7.513,7.513,0,1,1,7.513-7.513A7.507,7.507,0,0,1,14.159,21.892Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#c2c4d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsOff);
export default __webpack_public_path__ + "static/media/Logs-Off.5f70ea24c8166a94e14a5b891563cfbb.svg";
export { ForwardRef as ReactComponent };